import React, { InputHTMLAttributes } from 'react';

import styled from 'styled-components';

import useNodeParameter from '../../../../hooks/useNodeParameter';

const Select = styled.select`
  width: 100px;
  border: none;
  padding: 6px 10px;
  font-size: 12px;
  text-align: end;
  background-color: ${(props) => props.theme.editor.blockNode.inputBgColor};
  color: ${(props) => props.theme.global.textColor};
  border: 1px solid ${(props) => props.theme.global.borderColor};
`;

interface ParameterSelectProps extends InputHTMLAttributes<HTMLSelectElement> {
  nodeId: string;
  index: number;
  initValue: string;
}

const ParameterInput = React.forwardRef(
  ({ nodeId, index, initValue, ...rest }: ParameterSelectProps, ref: React.ForwardedRef<HTMLSelectElement>) => {
    const { onChange } = useNodeParameter({ id: nodeId, index, initValue, isSelect: true });

    return (
      <Select ref={ref} defaultValue={initValue} onChange={onChange} {...rest}>
        <option value="True">True</option>
        <option value="False">False</option>
      </Select>
    );
  }
);

export default React.memo(ParameterInput);
